import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Icon from 'shared/components/Icon';
import NumberBadge from './NumberBadge';

const NavOldLink = ({ path, label, icon, numberBadge }, context) => {
  const classes = cx({ active: context.router.isActive(path) });
  return (
    <li className={classes}>
      {' '}
      {/* TODO: Add active class as appropriate */}
      <a href={path}>
        <div className="sidebar-icon">
          <Icon name={icon} />
        </div>
        <span>{label}</span>
        <NumberBadge number={numberBadge} />
      </a>
    </li>
  );
};

NavOldLink.displayName = 'NavOldLink';

NavOldLink.contextTypes = { router: PropTypes.object };

NavOldLink.propTypes = {
  path: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  numberBadge: PropTypes.number,
};

export default NavOldLink;
